export const SETTINGS_CHANGE_SUCCESS = 'SETTINGS_CHANGE_SUCCESS';
export const SETTINGS_CHANGE_FAILED = 'SETTINGS_CHANGE_FAILED';
export const SETTINGS_START_EDITING = 'SETTINGS_START_EDITING';
export const UPDATE_SUBSCRIPTION_SETTING = 'UPDATE_SUBSCRIPTION_SETTING';
export const UPDATE_SUBSCRIPTION_SETTING_REQUEST =
  'UPDATE_SUBSCRIPTION_SETTING_REQUEST';

export const startEditing = settings => ({
  type: SETTINGS_START_EDITING,
  settings,
});

export const settingsChangeSuccess = settings => ({
  settings,
  type: SETTINGS_CHANGE_SUCCESS,
});

export const settingsChangeFail = data => ({
  ...data,
  type: SETTINGS_CHANGE_FAILED,
});

export const updateSubscriptionSetting = (id, subscribed) => ({
  type: UPDATE_SUBSCRIPTION_SETTING,
  id,
  subscribed,
});

export const updateSubscriptionSettingRequest = (id, subscribed) => ({
  type: UPDATE_SUBSCRIPTION_SETTING_REQUEST,
  id,
  subscribed,
});

export default {
  settingsChangeSuccess,
  startEditing,
};
